import styled from 'styled-components';
import { palette } from 'styled-tools';

import { FontSizes, FontWeights, Text } from '@calm-web/design-system';

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
	margin: 2rem 0;
`;

export const TermsText = styled(Text).attrs({
	el: 'p',
	size: FontSizes.sm,
	weight: FontWeights.Medium,
	noMargin: true,
})`
	color: rgba(0, 0, 0, 0.6);

	& a {
		color: ${palette('blue3')};
	}
`;
